module.exports = __webpack_public_path__ + "img/foot_icon3.c2ceae8f.png";